import React from 'react';
import MixerAndProportionInformationBindRouter from './MixerAndProportionInformationBindRouter';

export default function MixerAndProportionInformationBindPage() {
    return <MixerAndProportionInformationBindRouter />;
}
